import React from "react";
import { withStyles } from "@material-ui/core";
import classNames from "classnames";
import Dialog from "../../../../../components/Dialog/Dialog";
import ButtonLong from "../../../../../components/Button/ButtonLong";
import colors from "../../../../../template/Colors";
import { InputForm } from "../../../../../components/Input/InputDadosCadastraisPaciente";
import WarningIcon from "../../../../../components/Icon/WarningIcon";

const AlertaCancelamento = (props) => {
  const {
    open,
    classes,
    title,
    handleCancelar,
    handleContinuar,
    valueInput,
    onChangeMotivo,
  } = props;

  return (
    <Dialog
      open={open}
      classes={{
        paper: classes.paperAlert,
      }}
    >
      <div className={classNames(classes.icon, classes.yellow)}>
        <WarningIcon color='white' />
      </div>
      <div
        className={classNames(
          classes.title,
          classes.marginTop,
          classes.colorFont,
        )}
      >
        {title}
      </div>
      <>
        <div className={classes.titleInput}> Descreva o motivo do cancelamento aqui: </div>
        <InputForm
          id="pac-pod-inp-mot"
          multiline
          rows={3}
          value={valueInput}
          onChange={(e) => onChangeMotivo(e.target.value)}
          className={classes.inputMotivo}
        />
      </>
        <div className={classes.contentButtons}>
          <ButtonLong
            id="pac-pod-btn-cnc"
            colorCustom="transparency"
            onClick={handleCancelar}
            className={classes.buttonCancelar}
          >
            Cancelar
          </ButtonLong>
          <ButtonLong
            id="pac-pod-btn-cnf"
            colorCustom="green"
            onClick={handleContinuar}
            className={classes.noBoxShadow}
          >
            Confirmar
          </ButtonLong>
        </div>
    </Dialog>
  );
};

const styles = {
  paperAlert: {
    maxWidth: 300,
    borderRadius: "8px",
    padding: '24px',
  },
  icon: {
    width: 50,
    height: 50,
    borderRadius: 100,
    display: "flex",
    justifyContent: "center",
    alignSelf: "center",
    alignItems: "center",
  },
  title: {
    fontWeight: 600,
    fontSize: 24,
    alignSelf: "center",
    textAlign: "center",
  },
  yellow: {
    background: colors.commons.yellow2,
    color: colors.commons.white,
  },
  text: {
    textAlign: "justify",
  },
  marginTop: {
    marginTop: 16,
  },
  colorFont: {
    color: colors.commons.gray9,
  },
  contentButtons: {
    display: "flex",
    marginTop: 18,
  },
  noBoxShadow: {
    boxShadow: "none",
  },
  buttonCancelar: {
    border: "none",
    boxShadow: "none",
    marginRight: 16,
    "&:hover": {
      color: colors.commons.gray9,
      background: 'none'
    }
  },
  inputMotivo: {
    background: colors.commons.gray2,
		borderRadius: 10,
		padding: '0 10px',
		boxSizing: "borderBox",
  },
  titleInput: {
    fontSize: '12px',
  }
};

export default withStyles(styles)(AlertaCancelamento);
